
import { addSocketMessageListener } from "@/api/socketAPI";
import SocketMessageType from "@/constants/SocketMessageType";
import { store } from "@/store/store";

function updateGokrData( { body, } ) {
	const { goalId, } = body;
	store.dispatch( "goals/processGoalUpdate", { goalId, } );
}

export const initWebSocketListeners = () => {
	[
		SocketMessageType.GOAL_CREATED,
		SocketMessageType.GOAL_UPDATED,
		SocketMessageType.KEYRESULT_CREATED,
		SocketMessageType.KEYRESULT_UPDATED,
	].forEach( messageType => addSocketMessageListener( messageType, updateGokrData ) );

	addSocketMessageListener( SocketMessageType.GOAL_DELETED, ( { body, } ) => {
		const { goalId, } = body;
		store.dispatch( "goals/processGoalDeletedNotification", { goalId, } );
	} );

	addSocketMessageListener( SocketMessageType.KEYRESULT_DELETED, ( { body, } ) => {
		const { keyResultId, goalId, } = body;
		store.dispatch( "goals/processKeyResultDeletedNotification", { goalId, keyResultId, } );
	} );
};



// WEBPACK FOOTER //
// ./src/store/modules/goals/gokrApiOrchestrator.js